import styled from 'styled-components';
import Button from '@nebula/button';
import { rem } from 'polished';
import { Link } from '@experian-uk/corvetteuk-common-ui';
import { commonUi } from '../../constants';

export const Container = styled.div<{ $isWebview?: boolean }>`
  width: 100%;
  padding: 0;
  min-height: ${({ $isWebview }) =>
    $isWebview ? '100dvh' : `calc(100dvh - ${commonUi.layout.mobileHeaderHeightPx}px)`};

  @media ${({ theme }) => theme.media.tabletPortraitMin} {
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${({ theme }) => theme.color.ui.grey[10]};
    padding: ${rem(40)} ${rem(16)};
    min-height: ${({ $isWebview }) =>
      $isWebview ? '100dvh' : `calc(100dvh - ${commonUi.layout.tabletPortraitHeaderHeightPx}px)`};
  }

  @media ${({ theme }) => theme.media.smallDesktopMin} {
    min-height: ${({ $isWebview }) =>
      $isWebview ? '100dvh' : `calc(100dvh - ${commonUi.layout.smallDesktopHeaderHeightPx}px)`};
  }
`;

export const PageContainer = styled.div<{ $isWebview?: boolean }>`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin: 0 auto;
  min-height: ${({ $isWebview }) =>
    $isWebview ? '100dvh' : `calc(100dvh - ${commonUi.layout.mobileHeaderAndBottomNavHeightPx}px)`};
  /* min-height: calc(100dvh - ${commonUi.layout.mobileHeaderAndBottomNavHeightPx}px); */
  padding: ${rem(8)} ${rem(16)} ${rem(24)};
  font-family: 'Roboto', sans-serif;
  background-color: white;

  @media ${({ theme }) => theme.media.tabletPortraitMin} {
    min-height: auto;
    gap: ${rem(24)};
    padding: ${rem(32)} ${rem(80)};
    max-width: ${rem(596)};
    border-radius: ${rem(16)};
  }

  @media ${({ theme }) => theme.media.smallDesktopMin} {
    max-width: ${rem(800)};
  }
`;

export const MainSections = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: ${rem(32)};
  justify-content: center;
  width: 100%;
  min-height: 0;

  @media ${({ theme }) => theme.media.tabletPortraitMin} {
    flex: none;
    justify-content: flex-start;
  }
`;

export const TopSection = styled.div<{ $hasRefundSection?: boolean; $isWebview?: boolean }>`
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: ${rem(12)};
  justify-content: center;
  width: 100%;
  padding-top: ${({ $hasRefundSection }) => ($hasRefundSection ? rem(32) : 0)};

  @media ${({ theme }) => theme.media.tabletPortraitMin} {
    flex: none;
    gap: ${rem(16)};
    justify-content: flex-start;
    padding-top: 0;
  }
`;

export const BottomSection = styled.div`
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  gap: ${rem(16)};
  width: 100%;

  @media ${({ theme }) => theme.media.tabletPortraitMin} {
    gap: ${rem(32)};
  }
`;

export const Divider = styled.hr`
  border: none;
  border-top: 1px solid #e2e4e7;
  margin: 0;
  width: 100%;
  flex-shrink: 0;
`;

export const RefundSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${rem(4)};
  width: 100%;
`;

export const RefundTitle = styled.p`
  font-size: ${rem(18)};
  font-weight: 500;
  line-height: ${rem(28)};
  color: ${({ theme }) => theme.color.ui.grey[100]};
  margin: 0;
`;

export const RefundBody = styled.p`
  font-size: ${rem(14)};
  font-weight: 400;
  line-height: ${rem(24)};
  color: ${({ theme }) => theme.color.ui.grey[90]};
  margin: 0;
  @media ${({ theme }) => theme.media.tabletPortraitMin} {
    font-size: ${rem(16)};
  }
`;

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${rem(4)};
  width: 100%;
`;

export const Title = styled.h1`
  font-size: ${rem(28)};
  font-weight: 500;
  line-height: ${rem(40)};
  color: ${({ theme }) => theme.color.ui.grey[100]};
  margin: 0;
`;

export const Subtitle = styled.p`
  font-size: ${rem(16)};
  font-weight: 400;
  line-height: ${rem(24)};
  color: ${({ theme }) => theme.color.ui.grey[90]};
  margin: 0;
`;

export const InlineLink = styled(Link.Anchor)`
  font-size: inherit;
  color: ${({ theme }) => theme.color.ui.blue[70]};
  text-decoration: underline;
`;

export const SummaryCard = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: ${rem(20)} 0;

  @media ${({ theme }) => theme.media.tabletPortraitMin} {
    padding: ${rem(20)} 0 0;
  }
`;

export const SummaryTitle = styled.p`
  font-size: ${rem(18)};
  font-weight: 500;
  line-height: ${rem(28)};
  color: ${({ theme }) => theme.color.ui.grey[100]};
  margin: 0;
`;

export const DetailsGrid = styled.div`
  display: grid;
  grid-template-columns: ${rem(140)} minmax(0, 1fr);
  column-gap: ${rem(12)};
  row-gap: ${rem(12)};
  width: 100%;
  padding-top: ${rem(16)};

  @media ${({ theme }) => theme.media.tabletPortraitMin} {
    grid-template-columns: ${rem(160)} minmax(0, 1fr);
    column-gap: ${rem(16)};
  }
`;

export const DetailLabel = styled.span`
  font-size: ${rem(16)};
  font-weight: 400;
  line-height: ${rem(24)};
  color: ${({ theme }) => theme.color.ui.grey[90]};
`;

export const DetailValue = styled.span`
  font-size: ${rem(16)};
  font-weight: 500;
  line-height: ${rem(24)};
  color: ${({ theme }) => theme.color.ui.grey[100]};
`;

export const AlertWrapper = styled.div`
  width: 100%;
  > div {
    padding-top: 0;
    padding-bottom: 0;
  }
  > div > div {
    padding-top: 0;
    padding-bottom: 0;
  }

  > div > div > div p:nth-of-type(2) {
    margin-top: ${rem(6)};
  }
`;

export const CtaButton = styled(Button)`
  font-family: 'Roboto', sans-serif;
  font-weight: 500;
  width: 100%;
  margin-top: ${rem(24)};
  flex-shrink: 0;
  font-size: 14px;

  @media ${({ theme }) => theme.media.tabletPortraitMin} {
    width: fit-content;
    margin-top: 0;
  }
`;

export const SubtitleContent = styled.div`
  font-size: ${rem(16)};
  font-weight: 400;
  line-height: ${rem(24)};
  color: ${({ theme }) => theme.color.ui.grey[90]};

  span {
    display: block;
    margin-top: ${rem(24)};
  }
`;
